import TableOfContentsStyles from './TableOfContents.module.css';
import BordersStyles from './Borders.module.css';
import OpenBookCover from "./photos/BookDecorWebP/BookofAbdul_BookCover.webp";
import FrontBookCover from "./photos/BookDecorWebP/BookofAbdul_FrontBookCover.webp";
import BackBookCover from "./photos/BookDecorWebP/BookofAbdul_BackBookCover.webp";
import IndividualPage from "./photos/BookDecorWebP/BookofAbdul_Pages(Individual).webp";
import SigilDec from "./photos/BookDecorWebP/BookofAbdul_SigilDecoration.webp"
import { TableOfContentsLayout } from './Borders';


function TableOfContents() {
    const open =
        {
            title: "OpenBookCover",
            photo: OpenBookCover,
            id: 1
        };
    const page = 
        {
            title: "IndividualPage",
            photo: IndividualPage,
            id: 2
        };
    const front =
        {
            title: "FrontBookCover",
            photo: FrontBookCover,
            id: 3
        };
    const back = 
        {
            title: "BackBookCover",
            photo: BackBookCover,
            id: 4
        };
    const decs = 
        {
            title: "SigilDecoration",
            photo: SigilDec,
            id: 5
        };

    const pagenums = 13;

    return (
        <section className="Book-of-Abdul-Book-Placement">
            <div id="BoA-book-cover-open">
                <img id="BoA-open-img" src={open.photo} alt={open.title}/>
            </div>
            <div id="BoA-book-cover-front" style={{opacity: "0.0"}}>
                <img id="BoA-front-img" src={front.photo} alt={front.title}/>  
            </div>
            <div id="BoA-book-cover-back" style={{opacity: "0.0"}}>
                <img id="BoA-back-img" src={back.photo} alt={back.title}/>  
            </div>
            <div className="BoA-background-pages" id="BoA-background-pages">
                <ul className={TableOfContentsStyles["BoA-individual-pages"]}>
                    {[...Array(pagenums)].map((e, i) => (
                        <li className={"BoA-ToCpage-" + i} key={i}>
                            <img className="BoA-page-img" src={page.photo} alt={page.title} key={e}/>
                        </li>
                    ))}
                </ul>
                <div className={BordersStyles["BoA-page-content"]} id="BoA-page-content">
                    <TableOfContentsLayout 
                    section="Table of Contents" 
                    img={decs.photo} 
                    alt={decs.title}/>
                </div>
            </div>
        </section>
    );
}

export default TableOfContents;